import React from 'react'

export default class Contact extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            description: null,
            group: null,
            img: null,
        }
    }

    componentWillReceiveProps(props) {
        let {product} = props
        let {description, group, img} = this.state
        let productName = product.name
        this.props.dataApi.fetchContactData(function (response) {
                group = response[productName]['group']
                if (response[productName].hasOwnProperty('img')) {
                    img = response[productName]['img']
                } else {
                    img = null;
                }
                if (response[productName].hasOwnProperty('description')) {
                   description = response[productName]['description']
                } else {
                    description = null;
                }
                this.setState({description, group, img})
            }.bind(this)
        )
    }

    componentDidMount() {
        let {product} = this.props
        let {description, group, img} = this.state
        let productName = product.name
        this.props.dataApi.fetchContactData(function (response) {
                group = response[productName]['group']
                if (response[productName].hasOwnProperty('img')) {
                    img = response[productName]['img']
                } else {
                    img = null;
                }
                if (response[productName].hasOwnProperty('description')) {
                   description = response[productName]['description']
                } else {
                    description = null;
                }
                this.setState({description, group, img})
            }.bind(this)
        )
    }

    render() {
        const {product, translationData} = this.props
        let {description, group, img} = this.state
        const imgSrc = 'assets/images/company/' + product.logo

        return (
            <div className="row">
                <div className="row-no-margin">
                    <div className="selected-product-logo">
                        <img src={imgSrc} className="img-responsive" alt=""/>
                    </div>
                    {
                        ((group) =>{
                        switch(group) {
                            default:
                            case 4:
                            case 0:
                                return (
                                    <div className="contact-content row-eq-height">
                                        <div className="col-md-6 contact-step">
                                            <p className="step-title">{translationData.contact.general_title_0}</p>                                            
                                            <p className="step-comment" dangerouslySetInnerHTML={{__html: translationData.contact.general_content_opening_0}} />
                                            <p className="step-comment">Amgen Safety Net Foundation <br />PO Box 15980<br />Phoenix, AZ 85060-5980</p>
                                            <p className="step-comment">Fax: 1-833-959-1409</p>
                                        </div>
                                        <div className="col-md-6 contact-step">
                                            <p className="step-title">{translationData.contact.general_title_0_2}</p>
                                            <div className="row sub-row row-image">
                                                <div className="col-xs-4 image-column">
                                                    <img className="img-responsive" src="assets/images/support/amgen-support-plus.svg" alt="amgen assist" />
                                                </div>
                                                <div className="col-xs-8 image-column">
                                                    <p className="step-comment">
                                                        <a href='https://amgensupportplus.com/patient' target='_blank'>amgensupportplus.com/patient</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            case 1:
                                return (
                                <div className="contact-content row-eq-height">
                                    <div className="col-md-6 contact-step">
                                        <p className="step-title">{translationData.contact.general_title_1}</p>
                                        <div className="row sub-row row-image">
                                            <div className="col-xs-4 image-column">
                                                <img className="img-responsive" src="assets/images/support/amgen-support-plus.svg" alt="amgen assist" />
                                            </div>
                                            <div className="col-xs-8 image-column">
                                                <p className="step-comment" dangerouslySetInnerHTML={{__html: description}} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 contact-step">
                                        <p className="step-title">{translationData.contact.general_title_2}</p>
                                        <p className="step-comment" dangerouslySetInnerHTML={{__html: translationData.contact.general_content_opening_1}} />
                                        <p className="step-comment">Amgen Safety Net Foundation <br />2730 S. Edmonds Lane, Suite 300<br />Lewisville, TX 75067</p>
                                        <p className="step-comment">Fax: 1-844-465-1384</p>
                                    </div>
                                </div>
                                )
                            case 2:
                                return (
                                <div className="contact-content row-eq-height">
                                    <div className="col-md-6 contact-step">
                                        <p className="step-title">{translationData.contact.general_title_1}</p>
                                        <div className="row sub-row row-image">
                                            <div className="col-xs-4 image-column">
                                                <img className="img-responsive" src={'assets/images/support/' + img} alt="amgen assist" />
                                            </div>
                                            <div className="col-xs-8 image-column">
                                                <p className="step-comment" dangerouslySetInnerHTML={{__html: description}} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 contact-step">
                                        <p className="step-title">{translationData.contact.general_title_2}</p>
                                        <p className="step-comment" dangerouslySetInnerHTML={{__html: translationData.contact.general_content_opening_1}} />
                                        <p className="step-comment">Amgen Safety Net Foundation <br />2730 S. Edmonds Lane, Suite 300<br />Lewisville, TX 75067</p>
                                        <p className="step-comment">Fax: 1-844-465-1384</p>
                                    </div>
                                </div>
                                )
                            case 3:
                                return (
                                <div className="contact-content row-eq-height">
                                    <div className="col-md-6 contact-step">
                                        <p className="step-comment contact-3" dangerouslySetInnerHTML={{__html: description}} />
                                    </div>
                                    <div className="col-md-6 contact-step">
                                        <p className="step-title">{translationData.contact.general_title_2}</p>
                                        <p className="step-comment" dangerouslySetInnerHTML={{__html: translationData.contact.general_content_opening_1}} />
                                        <p className="step-comment">Amgen Safety Net Foundation <br />2730 S. Edmonds Lane, Suite 300<br />Lewisville, TX 75067</p>
                                        <p className="step-comment">Fax: 1-844-465-1384</p>
                                    </div>
                                </div>
                                )

                        }
                    }
                    )(group)}
                </div>
            </div>
        )
    }
}